import React from "react";
import Participant from "./Participant";
import * as PropTypes from "prop-types";
import ShadowScrollbars from "../../custom_scrollbars/ShadowScrollbars";
import classes from "classnames";

import '../../../../assets/sass/components/general/participants/participants.scss';

class Participants extends React.Component {

    setActiveIcon = () => {
        return this.props.activeIcon ?? null;
    }

    setInactiveIcon = () => {
        return this.props.inactiveIcon ?? null;
    }

    fixedIcon = () => {
        return this.props.fixedIcon ?? false;
    }

    toggleSelected = (index, active) => {
        if(this.props.itemToggleSelected)
            this.props.itemToggleSelected(index, active);
    }

    deleteItem = (index) => {
        if(this.props.deleteItem)
            this.props.deleteItem(index);
    }

    onFixedIconClick = (event, key) => {
        event.preventDefault();
        if(this.props.onFixedIconClick)
            this.props.onFixedIconClick(key);
    }

    render() {
        var {className, data, hasToggleIcon, hasClose} = this.props;

        return (
            <div className={classes("participants", className)}>
                <div className="member-list-wrapper">
                    <ShadowScrollbars>
                        <div className="member-list">
                            {
                                data.map((data, index) => {
                                    return (
                                        <Participant data={ data } hasClose={hasClose} hasToggleIcon={hasToggleIcon} activeIcon={this.setActiveIcon()} inactiveIcon={this.setInactiveIcon()} fixedIcon={this.fixedIcon()} onFixedIconClick={this.onFixedIconClick} toggleSelected={this.toggleSelected} deleteItem={this.deleteItem}></Participant>
                                    )
                                })
                            }
                        </div>
                    </ShadowScrollbars>
                </div>
            </div>
        );
    }

    static propTypes = {
        className: PropTypes.string,
        // object array to fill data.
        data: PropTypes.object.isRequired,
        // is has icon
        hasClose: PropTypes.bool,
        // is has icon
        hasToggleIcon: PropTypes.bool,
        // active icon.
        activeIcon: PropTypes.string,
        // inactive icon.
        inactiveIcon: PropTypes.string,
        // fixed Icon.
        fixedIcon: PropTypes.any,
        // fixed Icon event.
        onFixedIconClick: PropTypes.func
    };

    static defaultProps = {
        hasToggleIcon: true,
        hasClose: false,
    };
}

export default Participants;
